import { message } from 'hljd'

export const addChangeAttr = arr => arr.map(e => ({ ...e, isChanged: true }))

export const videoPrevCheck = (file, fileList) => {
  if (fileList.length > 10) {
    message.error({
      content: '上传视频数量不得超过10个',
      key: 'videoNum'
    })
    return false
  }
  if (file.size > 1024 * 1024 * 500) {
    message.error({
      content: '视频大小不能超过500M',
      key: 'videoSize'
    })
    return false
  } else {
    return true
  }
}

export const picPrevCheck = (file, fileList) => {
  if (fileList.length > 10) {
    message.error({
      content: '上传图片数量不得超过10张',
      key: 'picNum'
    })
    return false
  }
  if (file.size > 1024 * 1024 * 50) {
    message.error({
      content: '图片大小不能超过50M',
      key: 'picSize'
    })
    return false
  } else {
    return true
  }
}
